"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BibleComparisonMobileTab = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
const react_2 = require("@headlessui/react");
const Image_1 = require("../Image");
function BibleComparisonMobileTab(_a) {
    var { className, bibles, closeBible } = _a, props = __rest(_a, ["className", "bibles", "closeBible"]);
    const drawerInactive = bibles.length < 2;
    const [drawerOpen, setDrawerOpen] = (0, react_1.useState)(true);
    const toggleDrawerMobile = () => {
        setDrawerOpen(!drawerOpen);
    };
    // const closeAllBibles = () => {
    //   bibles.forEach((bible) => {
    //     closeBible(bible);
    //   });
    // };
    const noBibles = bibles.length !== 1;
    return (react_1.default.createElement("div", Object.assign({ id: "bc-tab-mobile", className: (0, classnames_1.default)(
        /* md:hidden block */ `fixed bottom-0 w-full left-0 shadow shadow-sm-all transition-transform ml-2 p-2 bg-white ${!drawerInactive || noBibles ? 'translate-y-full' : 'translate-y-0'}`, className) }, props),
        react_1.default.createElement("button", { className: `absolute left-1/2 top-0 -translate-x-1/2 -translate-y-full bg-white py-0.5 px-4 rounded-t-2xl z-108 group bg-white ${!drawerInactive || noBibles ? 'hidden' : 'block'}`, style: { boxShadow: '0 -3px 4px rgb(0 0 0 / 10%)' }, "aria-label": `${drawerOpen ? 'Close Compare Tab' : 'Open Compare Tab'}`, onClick: toggleDrawerMobile },
            react_1.default.createElement("span", { className: `bg-none relative bg-blue inline-block rounded-full p-0.5 text-white text-xs top-1 group-hover:bg-blue-hover transition-colors ${!drawerOpen ? ' ' : ''} ` }, !drawerOpen ? (react_1.default.createElement(fa_1.FaChevronUp, { className: "" })) : (react_1.default.createElement(fa_1.FaChevronDown, { className: "text-white text-xs" })))),
        react_1.default.createElement("div", { className: "relative flex flex-row justify-center" },
            react_1.default.createElement(react_2.Transition, { show: bibles.some((b) => b === 'bible-1'), leave: "transition-all duration-200 ease-out", leaveFrom: `transform  ${drawerOpen ? 'w-24' : 'w-12'} scale-100 opacity-100`, leaveTo: "transform w-0 scale-0 opacity-0", className: `relative ${drawerOpen ? 'w-24' : 'w-12'} transition-width mt-2 mx-3` },
                react_1.default.createElement("h3", { className: "sr-only" }, "RVR 1960 Biblia de Estudio para Mujeres, caf\u00E9 s\u00EDmil piel con \u00EDndice"),
                react_1.default.createElement("div", { className: "relative h-0 pb-1/1 w-full" },
                    react_1.default.createElement("div", { className: "absolute bottom-0 left-0 right-0 top-0" },
                        react_1.default.createElement(Image_1.Image, { className: "max-w-full max-h-full ml-auto mr-auto flex self-end", src: "/9781433648045?wid=130", alt: "RVR 1960 Biblia de Estudio para Mujeres, caf\u00E9 s\u00EDmil piel con \u00EDndice" }))),
                react_1.default.createElement("button", { className: `bg-none absolute -top-2 -right-2 ${!drawerOpen ? 'hidden' : ''}`, "aria-label": "Remove Item - RVR 1960 Biblia de Estudio para Mujeres, caf\u00E9 s\u00EDmil piel con \u00EDndice", onClick: () => closeBible('bible-1') },
                    react_1.default.createElement(fa_1.FaRegTimesCircle, null))),
            react_1.default.createElement("div", { className: "self-center px-2" },
                react_1.default.createElement("h2", { className: "text-sm sm:text-lg font-medium" }, "1 Bible Selected"),
                react_1.default.createElement("p", { className: `text-gray-5 text-xs sm:text-sm ${!drawerOpen ? 'hidden' : ''}` }, "You can choose one additional bible to compare")))));
}
exports.BibleComparisonMobileTab = BibleComparisonMobileTab;
